<script lang="ts">import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const SupportIcon = getIcon("SupportIcon");
</script>

{#if typeof SupportIcon === 'string'}
	<img src={SupportIcon} alt={$t(Verbiage.support_icon_alt, 'alts')} />
{:else if typeof SupportIcon === 'function'}
	<svelte:component this={SupportIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
